/**
 * @generated SignedSource<<494ac603a6bf3075325e2b65f58c3623>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorRoomSettings_package$data = {
  readonly hotel: {
    readonly id: string;
    readonly rooms: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly nameString: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"RoomNameWithCapacity_room">;
        };
      }>;
    };
  } | null;
  readonly id: string;
  readonly rooms: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentType": "RoomRatesEditorRoomSettings_package";
};
export type RoomRatesEditorRoomSettings_package$key = {
  readonly " $data"?: RoomRatesEditorRoomSettings_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorRoomSettings_package">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorRoomSettings_package",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Hotel",
      "kind": "LinkedField",
      "name": "hotel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 2147483647
            }
          ],
          "concreteType": "RoomConnection",
          "kind": "LinkedField",
          "name": "rooms",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoomEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Room",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "nameString",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RoomNameWithCapacity_room"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "rooms(first:2147483647)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "b31def63d1e6874029a39f36aa9a1630";

export default node;
